export  const LEGAL_DEBTOR_NAME = "legalDebtorName";
export  const DEBTOR_DESCRIPTION = "debtorDescription";
export  const DEBTOR_DESCRIPTION_LABEL = "Debtor Description";
export  const LEGAL_DEBTOR_LABEL = "Debtor Name";